import { HIGHLIGHT_STYLE } from 'modules/course/const/styles'

const HIGHLIGHT_STYLE_ID = 'lecture-highlight-style'

export const applyHighlightStylesToIframe = (
  iframe: HTMLIFrameElement | null,
  highlightColor?: string,
): void => {
  if (!iframe) return

  const iframeDoc = iframe.contentDocument
  if (!iframeDoc) return

  const iframeRoot = iframeDoc.documentElement
  if (!iframeRoot) return

  if (!highlightColor) return

  iframeRoot.style.setProperty('--color-system-warning-500', highlightColor)

  let styleEl = iframeDoc.querySelector<HTMLStyleElement>(`#${HIGHLIGHT_STYLE_ID}`)

  if (!styleEl) {
    styleEl = iframeDoc.createElement('style')
    styleEl.id = HIGHLIGHT_STYLE_ID
    styleEl.textContent = HIGHLIGHT_STYLE
    iframeDoc.head.append(styleEl)
  }
}

export const removeHighlightStylesFromIframe = (iframe: HTMLIFrameElement | null): void => {
  if (!iframe) return

  const iframeDoc = iframe.contentDocument
  if (!iframeDoc) return

  iframeDoc.documentElement?.style.removeProperty('--color-system-warning-500')

  const styleEl = iframeDoc.querySelector<HTMLStyleElement>(`#${HIGHLIGHT_STYLE_ID}`)

  if (styleEl) {
    styleEl.remove()
  }
}
